import axios from "axios";
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"

const state = () => ({
  simcards: {},
  allSimcards: [],
  customerSimcardService: 0,
  projectSimcardService: 0,
  allSimcardsCount: 0
});
const mutations = {
  setSimcards(state, userData) {
    state.simcards = userData.simcards;
  },
  setCustomerSimcardService(state, userData) {
    state.customerSimcardService = userData.customerSimcardService;
    localStorage.setItem(
      "customerSimcardService",
      userData.customerSimcardService
    );
  },
  setProjectSimcardService(state, userData) {
    state.projectSimcardService = userData.projectSimcardService;
    localStorage.setItem(
      "projectSimcardService",
      userData.projectSimcardService
    );
  },
  setAllSimcards(state, userData) {
    state.allSimcards = userData.allSimcards;
    localStorage.setItem(
      "setAllSimcards",
      JSON.stringify(userData.allSimcards)
    );
  },
  setAllSimcardsCount(state, userData) {
    state.allSimcardsCount = userData.allSimcardsCount;
    if (userData.projectId)
      localStorage.setItem("setAllSimcardsCurrent", userData.projectId);
    localStorage.setItem("allSimcardsCount", userData.allSimcardsCount);
  },
  setSimcardsLoading(state, userData) {
    state.simcardsLoading = userData.simcardsLoading;
    localStorage.setItem("simcardsLoading", userData.simcardsLoading);
  }
};
const actions = {
  clearSimcardsCache() {
    localStorage.removeItem("setAllSimcardsCurrent");
  },
  getAllSimcards({ commit, rootState }) {
    const projectStore = useProjectStore();
    const customerStore = useCustomerStore();
    let searchQuery;

    let currentProject = projectStore.selectedProject.projectId;
    let currentCustomer = customerStore.selectedCustomer.customerId;
    let getFromStorage = false;

    if (localStorage.getItem("setAllSimcardsCurrent")) {
      let storedProject = localStorage.getItem("setAllSimcardsCurrent");
      if (currentProject == storedProject) {
        getFromStorage = true;
      }
      // NOTE: do NOT flip setAllSimcardsCurrent to currentProject here. The flag
      // is set authoritatively only after a successful fetch (setAllSimcardsCount
      // with projectId). Flipping it before the fetch let a concurrent call for
      // the same project satisfy the cache check and serve the previous project's
      // single-slot list (empty []) as if it were this project's, so the table
      // stayed empty after A -> B -> A. (PIX-549)
    }
    searchQuery = "/simcards/project/" + currentProject;

    var now = new Date();

    if (
      !localStorage.getItem("simcardsCacheUpdateAt") ||
      new Date(localStorage.getItem("simcardsCacheUpdateAt")).getTime() <
        now.getTime()
    ) {
      getFromStorage = false;
    }
    if (!localStorage.getItem("allSimcardsLoading")) {
      if (getFromStorage) {
        commit("setAllSimcards", {
          allSimcards: JSON.parse(localStorage.getItem("setAllSimcards"))
        });
        commit("setAllSimcardsCount", {
          allSimcardsCount: localStorage.getItem("allSimcardsCount")
        });

        return true;
      } else {
        commit("setSimcardsLoading", {
          simcardsLoading: 1
        });

        // Reset the service flags to an "unknown" (0) value before the checks
        // re-run, so a slow service-check can't leave the previous project's
        // stale flag driving a wrong no-service/empty message (PIX-549).
        commit("setCustomerSimcardService", { customerSimcardService: 0 });
        commit("setProjectSimcardService", { projectSimcardService: 0 });

        // check SMS service exists for actual customer
        axios
          .get(
            process.env.VUE_APP_API +
              "/customers/" +
              currentCustomer +
              "/services?limit=1&productElementId[like]=s_iot8681"
          )
          .then(result => {
            console.log("check service SMS exists for customer", result);
            console.log(
              "check service SMS exists for customer",
              result.data.data.length
            );
            if (result.data.data.length) {
              commit("setCustomerSimcardService", {
                customerSimcardService: true
              });
            } else {
              commit("setCustomerSimcardService", {
                customerSimcardService: false
              });
            }
          })
          .catch(() => {
            // On failure commit a definite false instead of leaving the reset 0,
            // so a zero-row project can't get stuck on the loader (0 matches no
            // template branch). (PIX-549)
            commit("setCustomerSimcardService", { customerSimcardService: false });
          })

        // check SMS service exists for actual project
        axios
          .get(
            process.env.VUE_APP_API +
              "/projects/" +
              currentProject +
              "/services?limit=1&productElementId[like]=s_iot8681"
          )
          .then(result => {
            console.log("check service SMS exists for project", result);
            console.log(
              "check service SMS exists for project",
              result.data.data.length
            );
            if (result.data.data.length) {
              commit("setProjectSimcardService", {
                projectSimcardService: true
              });
            } else {
              commit("setProjectSimcardService", {
                projectSimcardService: false
              });
            }
          })
          .catch(() => {
            // On failure commit a definite false instead of leaving the reset 0,
            // so a zero-row project can't get stuck on the loader (0 matches no
            // template branch). (PIX-549)
            commit("setProjectSimcardService", { projectSimcardService: false });
          })

        return axios
          .get(process.env.VUE_APP_API + searchQuery, {
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "-1"
            }
          })
          .then(result => {
            commit("setAllSimcardsCount", {
              allSimcardsCount: result.data.metadata.count,
              projectId: currentProject
            });
            commit("setAllSimcards", {
              allSimcards: result.data.data
            });
            commit("setSimcardsLoading", {
              simcardsLoading: 0
            });
            let cacheUpdateAt = new Date();
            cacheUpdateAt.setSeconds(cacheUpdateAt.getSeconds() + 30);
            localStorage.setItem("simcardsCacheUpdateAt", cacheUpdateAt);
            return true;
          })
          .catch(() => {
            commit("setSimcardsLoading", {
              simcardsLoading: 0
            });
            return true;
          });
      }
    }
  }
};
const getters = {
  simcards: state => {
    return state.simcards;
  },
  simcardsLoading: state => {
    return state.simcardsLoading;
  },
  customerSimcardService: state => {
    return state.customerSimcardService;
  },
  projectSimcardService: state => {
    return state.projectSimcardService;
  },
  allSimcards: state => {
    return state.allSimcards;
  },
  allSimcardsCount: state => {
    return state.allSimcardsCount;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
